import service from '@/store/services/settings/sms-log-service';

const state = {
    list: [],
    log: null,
    meta: {},
    stats: {},
    isLoading: false,
    error: null
};

const mutations = {
    SET_LIST(state, list) {
        state.list = list;
    },
    SET_RESOURCE(state, log) {
        state.log = log;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
    SET_STATS(state, stats) {
        state.stats = stats;
    },
    SET_LOADING(state, status) {
        state.isLoading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    list({ commit }, params = {}) {
        commit('SET_LOADING', true);
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
                commit('SET_LOADING', false);
                return { list, meta };
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    get({ commit }, id) {
        commit('SET_LOADING', true);
        return service.get(id)
            .then(log => {
                commit('SET_RESOURCE', log);
                commit('SET_LOADING', false);
                return log;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    view({ commit }, params) {
        commit('SET_LOADING', true);
        return service.view(params)
            .then(log => {
                commit('SET_RESOURCE', log);
                commit('SET_LOADING', false);
                return log;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    getStats({ commit }, params = {}) {
        commit('SET_LOADING', true);
        return service.getStats(params)
            .then(stats => {
                commit('SET_STATS', stats);
                commit('SET_LOADING', false);
                return stats;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    resend({ commit }, payload) {
        commit('SET_LOADING', true);
        return service.resend(payload)
            .then(result => {
                commit('SET_LOADING', false);
                return result;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    clearError({ commit }) {
        commit('SET_ERROR', null);
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    meta: state => state.meta,
    log: state => state.log,
    stats: state => state.stats,
    isLoading: state => state.isLoading,
    error: state => state.error
};

const smsLogs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default smsLogs;